exports = module.exports = require("../../h5/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".temp-comp{width:100%;height:100px;background:#dcf3ff;color:#26b5ff;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}", ""]);

// exports
